import axios from 'axios';

const authHeader = () => {
  try {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const token = user?.token;

    if (!token) return {};

    return {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
  } catch (error) {
    console.error('Error retrieving token from localStorage', error);
    return {};
  }
};

const request = async (method, baseURL, endpoint, data = null) => {
  const config = {
    method,
    url: baseURL + endpoint,
    ...authHeader(),
  };
  if (data) config.data = data;

  const res = await axios(config);
  return res.data;
};

export const apiService = {
  get: (baseURL, endpoint) => request('get', baseURL, endpoint),
  post: (baseURL, endpoint, data) => request('post', baseURL, endpoint, data),
  put: (baseURL, endpoint, data) => request('put', baseURL, endpoint, data),
  patch: (baseURL, endpoint, data) => request('patch', baseURL, endpoint, data),
  delete: (baseURL, endpoint) => request('delete', baseURL, endpoint),
};
